import { useEffect, useRef, useState } from 'react';

export default function AboutSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="bg-white py-24 md:py-32" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="max-w-2xl">
            <span className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-3 block">About Us</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              K・Sキャピタル<br />
              <span className="text-[#0ea5e9]">合同会社</span>
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              私たちは、企業の経理業務をクラウドで一括管理するシステムの開発・提供を行っています。
              売上・入出金・請求・支払情報のデータ管理と可視化を通じて、
              お客様の業務効率化と経営判断の迅速化を支援します。
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-[#f0f9ff]">
                  <i className="ri-map-pin-line text-[#0ea5e9] text-sm" />
                </div>
                <span className="text-gray-700 text-sm">東京都板橋区小豆沢3-3-4-305</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-[#f0f9ff]">
                  <i className="ri-calendar-line text-[#0ea5e9] text-sm" />
                </div>
                <span className="text-gray-700 text-sm">設立 平成30年3月16日（2018年）</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-md bg-[#f0f9ff]">
                  <i className="ri-building-2-line text-[#0ea5e9] text-sm" />
                </div>
                <span className="text-gray-700 text-sm">合同会社</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
